(function () {
  var SECTION_SELECTOR = '.oddit-section-reviews-carousel';
  var sectionState = new Map();

  function initSection(section) {
    var track = section.querySelector('.oddit-section-reviews-carousel__track');
    if (!track) return;

    var prevBtns = section.querySelectorAll('.oddit-section-reviews-carousel__arrow--prev');
    var nextBtns = section.querySelectorAll('.oddit-section-reviews-carousel__arrow--next');
    var cards = track.querySelectorAll('.oddit-section-reviews-carousel__card');
    if (cards.length === 0) return;

    var state = {
      track: track,
      abortController: new AbortController(),
      autoplayTimer: null,
      mutationObserver: null
    };

    var signal = state.abortController.signal;

    function getCardWidth() {
      var card = cards[0];
      var style = getComputedStyle(track);
      var gap = parseFloat(style.gap) || 0;
      return card.offsetWidth + gap;
    }

    function killAutoplay() {
      autoplayEnabled = false;
      stopAutoplay();
    }

    function scrollPrev() {
      killAutoplay();
      var cardWidth = getCardWidth();
      track.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    }

    function scrollNext() {
      var cardWidth = getCardWidth();
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= maxScroll - 1) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: cardWidth, behavior: 'smooth' });
      }
    }

    for (var i = 0; i < prevBtns.length; i++) {
      prevBtns[i].addEventListener('click', scrollPrev, { signal: signal });
    }
    for (var j = 0; j < nextBtns.length; j++) {
      nextBtns[j].addEventListener('click', scrollNext, { signal: signal });
    }

    track.addEventListener('touchstart', function () {
      killAutoplay();
    }, { passive: true, signal: signal });

    /* Autoplay */
    var autoplayEnabled = section.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = (parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5) * 1000;

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled) return;
      state.autoplayTimer = setInterval(scrollNext, autoplaySpeed);
    }

    function stopAutoplay() {
      if (state.autoplayTimer) {
        clearInterval(state.autoplayTimer);
        state.autoplayTimer = null;
      }
    }

    if (autoplayEnabled) {
      startAutoplay();

      section.addEventListener('mouseenter', stopAutoplay, { signal: signal });
      section.addEventListener('mouseleave', startAutoplay, { signal: signal });
      section.addEventListener('focusin', stopAutoplay, { signal: signal });
      section.addEventListener('focusout', startAutoplay, { signal: signal });
    }

    /* Ensure the peeking last card reveals with the in-view cards.
       The overflow container can prevent the IntersectionObserver from
       firing on partially-visible cards, so we watch for the first card
       to get its 'is-visible' class and then add it to the last card too. */
    var lastCard = cards[cards.length - 1];
    if (lastCard && lastCard.classList.contains('oddit-reveal') && !lastCard.classList.contains('is-visible')) {
      var firstCard = cards[0];
      var mo = new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          if (firstCard.classList.contains('is-visible')) {
            lastCard.classList.add('is-visible');
            mo.disconnect();
            state.mutationObserver = null;
            break;
          }
        }
      });
      mo.observe(firstCard, { attributes: true, attributeFilter: ['class'] });
      state.mutationObserver = mo;
    }

    sectionState.set(section, state);
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    if (state.autoplayTimer) {
      clearInterval(state.autoplayTimer);
    }
    if (state.mutationObserver) {
      state.mutationObserver.disconnect();
    }
    state.abortController.abort();
    sectionState.delete(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
